export const pillMarker = () => ({
  markerLeft: 0,
  markerWidth: 0,
  mutationObserver: null,
  resizeObserver: null,

  init() {
    this.updateMarker();

    this.mutationObserver = new MutationObserver(() => this.updateMarker());
    this.resizeObserver = new ResizeObserver(() => this.updateMarker());

    this.mutationObserver.observe(this.$el, {
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-selected"],
    });

    this.resizeObserver.observe(this.$el);
  },

  destroy() {
    this.mutationObserver?.disconnect();
    this.resizeObserver?.disconnect();
  },

  updateMarker() {
    const selected = this.$el.querySelector('[aria-selected="true"]');

    if (selected) {
      this.markerLeft = selected.offsetLeft;
      this.markerTop = selected.offsetTop;
      this.markerHeight = selected.offsetHeight;
      this.markerWidth = selected.offsetWidth;
    }
  },
});
